/*
LocalStorage keys
*/
export const storage = {
    leftSidebar: '__left_sidebar',
    tokenName: '',
    calculationCopies: 'calculationCopies',
}

/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = "menu-sub-hidden"

export const subHiddenBreakpoint = 1440
export const menuHiddenBreakpoint = 768

// Toaster
export const defaultToaster = {
    toasterType: "OK",
    title: '',
    message: '',
    counter: 0
}

export const defaultLeftSidebar = ''

//fetch state
export const initialFetchState = {
    data: {},
    isFetching: false,
    shouldReload: false,
    errors: {},
    message: '',
    reduxStructure: true
}

export const initialInfoFetchState = {
    data: {},
    isFetching: true,
    shouldReload: false,
    errors: {},
    message: '',
    reduxStructure: true
}

//enum fetch Item state
export const initialEnumItemFetchState = {
    data: [],
    isFetching: false,
    shouldReload: false
}

//user state
export const initialUserFetchState = {
    isAuthenticated: false,
    isFetching: false,
    user: {},
}

export const initialIntervalChanges = {
    hd_notify: false,
}


